import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { Storage, ref, uploadString, percentage, uploadBytesResumable, UploadTask } from '@angular/fire/storage';

import { environment } from '../../../../environments/environment';
import { ResourceService } from '../../../_services/resource.service';

@Component({
    selector: 'ngx-resource-edit-modal',
    templateUrl: 'resource-edit-modal.component.html',
    styleUrls: ['resource-edit-modal.component.scss'],
    standalone: false
})
export class ResourceEditModalComponent {

  originalModel;

  _model;
  istemplate = false
  customObject
  @Input() set model(model){
    this._model = {...model};
    this.istemplate = model.collectionPath.includes('template')
    this.originalModel = model;
  };

  @Input() languages;
  @Input() type;
  @Input() game;

  currentResourceImage;
  task:any;
  progress: any;  // Observable 0 to 100
  progressMap = {};

  constructor(protected ref: NbDialogRef<ResourceEditModalComponent>,
    public resourceService: ResourceService,
    private storage: Storage) {}

  async handleFileUpdated(objectImage, lang){
    console.log('New object image is:'+objectImage);
    this.currentResourceImage = objectImage;
    await this.saveObjectImage(lang);
  }

  async saveObjectImage(lang){
    
    const filePath = this._model.collectionPath; //`games/${this._model.gameId}/objects/`;
    let fileName = `/${this._model.id}${lang ? '_'+lang : ''}.jpg`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, this.currentResourceImage, 'data_url');
    let blob = await (await fetch(this.currentResourceImage)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      if(!lang){
        this._model.pictureUrl = url;
        this._model.filePath = filePath+fileName;
        this._model.pictureLastUpdate = new Date().getTime();
        await this.resourceService.updateResource(this._model, {pictureUrl:this._model.pictureUrl, filePath:this._model.filePath, pictureLastUpdate: this._model.pictureLastUpdate});
      }
      else{
        this._model.objectPic[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        await this.resourceService.updateResource(this._model, {objectPic:this._model.objectPic});
      }
      setTimeout(() => {
        delete this.progressMap['OBJECT'+(lang ? lang : '')];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['OBJECT'+(lang ? lang : '')] =  Math.round(percentage.progress);
    });
  }

  cancel() {
    this.ref.close();
  }

  deletePicture(lang){
    if(!lang) this._model.pictureUrl = ''
    else {
      this._model.objectPic[lang] = {}
    }
  }

  async save() {
    //this.originalModel = this._model;
    //Object.assign(this.originalModel, this._model);
    console.log('Save object:'+JSON.stringify(this._model));
    if(this._model.id){
      await this.resourceService.updateResource(this._model, {...this._model});
    }
    else{
      console.log('create object:'+this._model.collectionPath);
      if(this._model.collectionPath.indexOf('games/')>=0){
        this._model.scope = 'game';
      }
      await this.resourceService.addResource(this._model); 
    }
    this.ref.close(this.originalModel);
  }
}
